import { makeStyles } from '@material-ui/core/styles';

import { cardRadius, cardShadow, colors } from '../../tokens';

const useStyles = makeStyles(theme => ({
  emptyTableCard: {
    height: 486,
    borderRadius: cardRadius,
    boxShadow: cardShadow,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  emptyWithdrawalCard: {
    minHeight: 380,
    borderRadius: cardRadius,
    boxShadow: cardShadow,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  emptyIcon: {
    color: '#bdbdbd',
    fontSize: 76,
    marginBottom: theme.spacing(2),
  },
  emptyTitle: {
    color: colors.textSecondary,
    fontSize: 20,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  emptyDescription: {
    color: colors.textSecondary,
    fontSize: 16,
  },
}));

export default useStyles;
